import React from 'react'
import { Parser } from '../../common'

const Content = ({ block }) => {
    return (
        <>
            {block?.content && <p>{block.content}</p>}
            {block?.childrens && <Parser content_block={block.childrens} />}
        </>
    )
}

export default Content
